import { Component, Input } from '@angular/core';
import { Church } from '../../church';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent {

  @Input() churches: Church[];

  constructor() { }
}
